module.exports = __webpack_public_path__ + "fonts/PressStart2P-Regular.26e8251b.ttf";